<ng-container *ngIf="canShowHelp">
	<div *ngIf="isMobile" class="need-section-section">
		<div class="section">
			<div class="need-help-text">
				<svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
					<path
						d="M7.99992 14.6673C4.31802 14.6673 1.33325 11.6825 1.33325 8.00065C1.33325 4.31875 4.31802 1.33398 7.99992 1.33398C11.6818 1.33398 14.6666 4.31875 14.6666 8.00065C14.6625 11.6809 11.6801 14.6633 7.99992 14.6673ZM7.33325 11.334V12.6673H8.66659V11.334H7.33325ZM7.99992 4.66732C8.7363 4.66732 9.33325 5.26427 9.33325 6.00065C9.3356 6.35447 9.19355 6.69394 8.93992 6.94065L8.11325 7.78065C7.61421 8.2818 7.33379 8.96008 7.33325 9.66732V10.0007H8.66659C8.61477 9.28399 8.90382 8.58483 9.44659 8.11398L10.0466 7.50065C10.4453 7.10353 10.6686 6.56339 10.6666 6.00065C10.6666 4.52789 9.47268 3.33398 7.99992 3.33398C6.52716 3.33398 5.33325 4.52789 5.33325 6.00065H6.66659C6.66659 5.26427 7.26354 4.66732 7.99992 4.66732Z"
						fill="#0B3275" fill-opacity="0.4"/>
				</svg>
				Need Help?
			</div>
			<div (click)="openSupport()" class="need-help-link addCursor">
				<a> Click Here</a>
			</div>
		</div>
	</div>
	<div (click)="openSupport()" *ngIf="!isMobile" class="floating-button flex-container align-center addCursor">
		<svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M13.1999 3.59844C13.1999 2.9357 12.6626 2.39844 11.9999 2.39844C11.3372 2.39844 10.7999 2.9357 10.7999 3.59844V4.79844C10.7999 5.46118 11.3372 5.99844 11.9999 5.99844C12.6626 5.99844 13.1999 5.46118 13.1999 4.79844V3.59844Z"
				fill="white"/>
			<path
				d="M18.7881 6.90721C19.2567 6.43858 19.2567 5.67878 18.7881 5.21015C18.3194 4.74152 17.5597 4.74152 17.091 5.21015L16.2425 6.05868C15.7739 6.52731 15.7739 7.2871 16.2425 7.75573C16.7111 8.22436 17.4709 8.22436 17.9395 7.75573L18.7881 6.90721Z"
				fill="white"/>
			<path
				d="M21.5999 11.9984C21.5999 12.6612 21.0626 13.1984 20.3999 13.1984H19.1999C18.5372 13.1984 17.9999 12.6612 17.9999 11.9984C17.9999 11.3357 18.5372 10.7984 19.1999 10.7984H20.3999C21.0626 10.7984 21.5999 11.3357 21.5999 11.9984Z"
				fill="white"/>
			<path
				d="M6.06013 7.75575C6.52876 8.22438 7.28856 8.22438 7.75718 7.75575C8.22581 7.28713 8.22581 6.52733 7.75718 6.0587L6.90866 5.21017C6.44003 4.74154 5.68023 4.74154 5.2116 5.21017C4.74297 5.6788 4.74297 6.4386 5.2116 6.90723L6.06013 7.75575Z"
				fill="white"/>
			<path
				d="M5.9999 11.9984C5.9999 12.6612 5.46264 13.1984 4.7999 13.1984H3.5999C2.93716 13.1984 2.3999 12.6612 2.3999 11.9984C2.3999 11.3357 2.93716 10.7984 3.5999 10.7984H4.7999C5.46264 10.7984 5.9999 11.3357 5.9999 11.9984Z"
				fill="white"/>
			<path
				d="M9.5999 19.1984V17.9984H14.3999V19.1984C14.3999 20.5239 13.3254 21.5984 11.9999 21.5984C10.6744 21.5984 9.5999 20.5239 9.5999 19.1984Z"
				fill="white"/>
			<path
				d="M14.401 16.7984C14.4185 16.39 14.649 16.0229 14.9721 15.7678C16.0854 14.8888 16.7999 13.527 16.7999 11.9984C16.7999 9.34747 14.6509 7.19844 11.9999 7.19844C9.34894 7.19844 7.1999 9.34747 7.1999 11.9984C7.1999 13.527 7.91444 14.8888 9.02773 15.7678C9.35079 16.0229 9.58132 16.39 9.59883 16.7984H14.401Z"
				fill="white"/>
		</svg>
		Need Help?
	</div>
</ng-container>
